import axios from "axios";
import store from "../store";
// import router from "../router";

const appBaseURL = process.env.VUE_APP_API_BASE_URL;

class BaseModule {
  constructor(baseURL = appBaseURL) {
    this.$http = axios.create({
      baseURL
    });
    this.$http.interceptors.request.use(
      config => {
        const token = store.state.tokenContent;
        config.headers.Authorization = `Bearer ${token}`;
        if (window.timeZone) {
          config.headers.is_timezone = window.timeZone;
        }
        return config;
      },
      error => Promise.reject(error)
    );
    this.$http.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        switch (error.response && error.response.status) {
          // case 401:
          // case 403:
          //   router.push({ name: "login" });
          //   store.commit("logout");
          //   return error.response;
          default:
            return Promise.reject(error);
        }
      }
    );
  }

  get(url, config = {}) {
    return this.$http.get(url, {
      ...config,
      params: {
        ...config.params,
        storeGuid: store.state.storeId,
        store_guid: store.state.storeId,
        zipCode: store.state.zipCode
      }
    });
  }

  post(url, data = undefined, config = {}) {
    return this.$http.post(url, this.handleData(data), config);
  }

  put(url, data = undefined, config = {}) {
    return this.$http.put(url, this.handleData(data), config);
  }

  delete(url, config = {}) {
    return this.$http.delete(url, config);
  }

  handleData(data) {
    return {
      ...data,
      storeGuid: store.state.storeId,
      zipCode: store.state.zipCode
    };
  }
}

export default BaseModule;
